import Backbone from 'backbone';
import React from 'react';

import makeCancelable, {CancelablePromise} from 'lib/makeCancelable';
import {Member} from 'orgs/OrganizationConstants';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import * as DateUtil from 'util/DateUtil';

import ActivityLogUserSelector from './ActivityLogUserSelector';
import ActivityRow from './ActivityRowTemplate';
// @ts-expect-error
import {adminGet} from './Helpers';

class AdminLogView extends Backbone.View<Backbone.Model> {
  _searchPromise?: CancelablePromise<
    Array<{
      id: number;
      created_at: string;
      handle: string;
      method: string;
      text: string;
      profile_url: string;
      support_delegate_email: string;
      support_delegate_type: string | null;
    }>
  >;
  selectedMember: Member | null = null;

  static initClass(): void {
    this.prototype.el = '#activity-log';

    this.prototype.events = {
      // @ts-expect-error: Backbone events can be either the events hash or a method returning the events hash
      // The Backbone types do not know about this.
      'click .js-refresh': 'makeRequest',
    };
  }

  renderUserSelector(): void {
    renderToDOM(
      <ActivityLogUserSelector
        organizationId={window.bootstrap!.organization_id!}
        selectedMember={this.selectedMember}
        setSelectedMember={(member) => {
          this.selectedMember = member;
          this.renderUserSelector();
        }}
      />,
      this.$('.js-select-user')[0]
    );
  }

  makeRequest(): void {
    this.$('.spinner').removeClass('hidden');
    this.$('tbody').empty();
    const args: {q?: string; until?: string; user_id?: string} = {};
    const userValue = this.selectedMember?.id;
    if (userValue) {
      args.user_id = userValue;
    }
    const q = this.$('.message-search').val();
    if (q.length !== 0) {
      args.q = q;
    }
    const dateSearch = this.$('.date-search input').val();
    if (dateSearch.length !== 0) {
      args.until = dateSearch;
    }
    if (this._searchPromise) {
      this._searchPromise.cancel();
    }
    this._searchPromise = makeCancelable(Promise.resolve(adminGet('/1/api/admin/search', args)));
    this._searchPromise.promise.then((res) => {
      this.$('.spinner').addClass('hidden');
      const result = [];
      for (const info of res) {
        // eslint-disable-next-line new-cap -- This is a React component wrapped with a Jade compatibility shim
        const row = ActivityRow({
          profile_url: info.profile_url,
          handle: info.handle,
          supportDelegateEmail: info.support_delegate_email,
          text: info.text,
          time: DateUtil.readableTime(new Date(info.created_at)),
        });
        result.push(this.$('tbody').append(row));
      }
      return result;
    });
  }

  // @ts-expect-error Backbone render functions should return `this`
  render(): void {
    this.renderUserSelector();
    this.makeRequest();
  }
}

AdminLogView.initClass();

export default AdminLogView;
